import React, { useEffect } from 'react';
import ReactModal from 'react-modal';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { RegularButton, ICommonDropdownOption, AlertAdapter, CommonDropdown } from 'pg-ui-library';
import { IUser } from 'src/interfaces';
import { useUpdateuser } from '../../mutations/user-setting.mutation';
import { ModalContent, Header, AllContent, MainContent, StatusContainer, StatusLabel, Footer } from './styles';

export const activeOptions: ICommonDropdownOption[] = [
  { key: 'false', label: 'Inactive', value: 'false' },
  { key: 'true', label: 'Active', value: 'true' },
];

export const ExternalModal: React.FC<{
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  user: IUser;
  onSuccess: () => void;
}> = ({ isOpen, setIsOpen, user, onSuccess }) => {
  const updateUser = useUpdateuser();

  const formik = useFormik({
    initialValues: {
      userId: user?.id,
      isActive: user?.isActive ? 'true' : 'false',
    },
    validationSchema: yup.object().shape({
      isActive: yup.string().required(),
    }),
    onSubmit: async values => {
      const updatedValues = {
        ...values,
        isActive: values.isActive === 'true',
        // Always include a default permission object
        permission: {
          benefits: false,
          documents: false,
          tax_forms: false,
          pay_history: false,
          hr_profile: false,
          admin: false,
        },
      };
      try {
        await updateUser.mutateAsync({ updateUser: updatedValues });
        AlertAdapter('Updated successfully', 'success');
        setIsOpen(false);
        if (onSuccess) onSuccess();
      } catch (error) {
        const errorMsg = error?.toString() || 'An error occurred while updating the user';
        AlertAdapter(errorMsg, 'error');
      }
    },
  });

  useEffect(() => {
    if (user) {
      formik.setValues({
        isActive: user?.isActive ? 'true' : 'false',
        userId: user.id,
      });
    }
    // eslint-disable-next-line
  }, [user]);

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={() => setIsOpen(false)}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '755px',
          height: '343px',
          display: 'flex',
          flexDirection: 'column',
          padding: '0',
          background: '#F3F4F8',
          overflowY: 'hidden',
        },
      }}
    >
      <ModalContent>
        <Header>
          <h3>Edit User</h3>
        </Header>
        <AllContent>
          <MainContent>
            <StatusContainer>
              <StatusLabel>Status</StatusLabel>
              <div style={{ minWidth: '100%', marginTop: '10%' }}>
                <CommonDropdown
                  label=""
                  id="isActive"
                  name="isActive"
                  options={activeOptions}
                  value={formik.values.isActive}
                  setValue={(value: string) => formik.setFieldValue('isActive', value)}
                  selectStyle={{
                    width: '100%',
                    marginTop: '8px',
                    height: 'auto',
                  }}
                />
              </div>
            </StatusContainer>
          </MainContent>
          <Footer>
            <RegularButton
              type="button"
              onClick={() => setIsOpen(false)}
              style={{ color: '#4948AC', backgroundColor: '#fff' }}
            >
              Cancel
            </RegularButton>
            <RegularButton
              type="submit"
              onClick={() => formik.handleSubmit()}
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Save
            </RegularButton>
          </Footer>
        </AllContent>
      </ModalContent>
    </ReactModal>
  );
};
